module.exports = __webpack_public_path__ + "img/18.2250f726.svg";